import React, { useState, useEffect } from 'react';
import { apiFetch } from '../services/apiClient';
import './ApplicationUrlDisplay.css';

const ApplicationUrlDisplay = ({ jobId }) => {
    const [applicationUrl, setApplicationUrl] = useState('');
    const [copied, setCopied] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchApplicationUrl();
    }, [jobId]);

    const fetchApplicationUrl = async () => {
        try {
            const response = await apiFetch(`/api/jobs/${jobId}/application-url`, {
            });
            if (response.ok) {
                const data = await response.json();
                setApplicationUrl(data.application_url);
            }
        } catch (error) {
            console.error('Error fetching application URL:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(applicationUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error('Error copying to clipboard:', error);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = applicationUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    if (loading) {
        return <div className="application-url-display">Loading...</div>;
    }

    return (
        <div className="application-url-display">
            <h3>Application URL</h3>
            <p className="help-text">
                Copy this URL and use it when posting your job on LinkedIn. 
                Candidates will be redirected to your application form.
            </p>
            
            <div className="url-container">
                <input
                    type="text"
                    value={applicationUrl}
                    readOnly
                    className="url-input"
                    onClick={(e) => e.target.select()}
                />
                <button 
                    onClick={handleCopy}
                    className="copy-button"
                >
                    {copied ? '✓ Copied!' : '📋 Copy'}
                </button>
            </div>

            <div className="instructions">
                <h4>How to use:</h4>
                <ol>
                    <li>Copy the application URL above</li>
                    <li>Post your job on LinkedIn</li>
                    <li>In the job posting settings, set "Application URL" to the copied URL</li>
                    <li>When candidates click "Apply", they'll be redirected to your form</li>
                </ol>
            </div>
        </div>
    );
};

export default ApplicationUrlDisplay;
